import { APP_RELEASE } from './release';

export const environment = {
    production: true,
    isDev: true,
    captureDebug: true,
    domainId: 'YS',
    domain: 'https://staging-admin.ysdev.co.uk/',
    environmentName: 'staging',
    release: APP_RELEASE,
    stripeKey: 'pk_test_M46bUsYimK0DbF7d17s4wkHD',
    imageUploadPath: 'https://staging-api.ysdev.co.uk/',
    apiPath: 'https://staging-api.ysdev.co.uk/',
    socketPath: 'https://staging-api.ysdev.co.uk/',
    posthogKey: 'phc_qoAzVMA8Tt4Xe5atXuWWHJ957aThTTEtCuoVrt7X7BSY',
    posthogHost: 'https://eu.i.posthog.com',
    // Empty until a staging-admin DSN is provided (init no-ops on empty).
    sentryDsn: '',
    siteUrl: 'https://staging-www.ysdev.co.uk/',
    publicSiteUrl: 'https://staging-www.ysdev.co.uk/',
    adminSiteUrl: 'https://staging-admin.ysdev.co.uk/',
    tinymceApiKey: '88ar931n5931tb0bgopl9jai12nrhu3gk3edqhxl0sp5to0e',
    emulateSslForLocalDev: true
};
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
